export default __webpack_public_path__ + "static/media/select_arrow_white.9b0dadd8.svg";